// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/chat/chat.css
// module id = 311
// module chunks = 0